/* Centralized event service for all the web so different parts can communicate.
 * All events are tied to document.
 */

/*----------------------------------------------------------------------
 * Event names
 */
const eventNames = {

  /* Intended to tell when there are unsaved changes on a page, so confirmation
   * is required to exit the page (e.g. going back) */
  PAGE_UNSAVED: 'xmira-page-unsaved',

  /* Intended to tell that everything is saved, so confirmation is not needed
   * to exit the page */
  PAGE_SAVED: 'xmira-page-saved',

  /* Intended to be fired when audio starts so other audios know they have to
   * stop, also to trigger play count increment */
  AUDIO_PLAYER_START: 'xmira-audio-player-start',

};

/*----------------------------------------------------------------------
 * Methods
 */
const addListener = (eventName, callback) => {
  document.addEventListener(eventName, callback);
}

const removeListener = (eventName, callback) => {
  document.removeEventListener(eventName, callback);
}

/*
 * Parameter `target` is optional to a dispatcher so later it can be known
 * who fired the event. If not, document is used as dispatcher.
 */
const dispatch = (eventName, target) => {
  const event = document.createEvent('Event');
  event.initEvent(eventName, true, true);
  if(target !== undefined) {
    target.dispatchEvent(event);
  } else {
    document.dispatchEvent(event);
  }
}


/*----------------------------------------------------------------------
 * Exports
 */
export default {
  ...eventNames,
  addListener,
  removeListener,
  dispatch,
};
